import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom'
import InputTextField from '../../../../../component/input/inputTextField'
import LabelCustom from '../../../../../component/label/LabelCustom'

// COMPONENT
import * as styled from '../../../style/main.style'
import Header from '../../../Header'
import Navbar from '../../../Navbar'
import { FiscalYearApi, updateNotificationConfig } from '../../../../../api/fiscal-year/fiscalyear.api';
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import { swalError, swalSuccess } from '../../../../../component/notification/swal'
import Loading from '../../../../../component/loading/Loading'


const NotificationSetting: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const permission = useSelector((state: any) => state?.permission?.permission);


    const [notificationConfig, setNotificationConfig] = useState<updateNotificationConfig>({
        notifyProgressAt: 0,
        notifyStatusAt: 0
    })

    const handleGetNotificationConfig = async () => {
        dispatch(setLoading())
        await FiscalYearApi.getNotificationConfig(idFiscalYear)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { notifyProgressAt, notifyStatusAt } = res.data?.result;
                    setNotificationConfig((prev) => ({
                        ...prev,
                        notifyProgressAt,
                        notifyStatusAt
                    }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }

    const handleUpdateNotificationConfig = async () => {
        if (notificationConfig.notifyProgressAt > 31 || notificationConfig.notifyProgressAt === 0 || notificationConfig.notifyStatusAt > 31 || notificationConfig.notifyStatusAt === 0) {
            swalError("กรุณาตรวจสอบวันที่ให้ถูกต้อง")
        } else {
            dispatch(setLoading())
            await FiscalYearApi.updateNotificationConfig(idFiscalYear, notificationConfig)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        console.log(res.data)
                        swalSuccess(res.data?.description)
                    } else {
                        swalError(res.response?.data?.description)
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
                .finally(() => handleGetNotificationConfig())
        }
    }

    useEffect(() => {
        handleGetNotificationConfig();
    }, [])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <div>
                            <Typography className='text-primary' variant='h4'>
                                {`ปีงบประมาณ ${idFiscalYear === 0 ? '' : idFiscalYear} / การแจ้งเตือน`}
                            </Typography>
                        </div>
                        <span>
                            {permission?.find((list: any) => list?.code === "Notification.Edit")?.permit === true && (
                                <ButtonContained
                                    onClick={handleUpdateNotificationConfig}
                                >
                                    <Typography>{t("BUTTON.SAVE")}</Typography>
                                </ButtonContained>
                            )}
                        </span>
                    </styled.TopicHeader>

                    <section className='w-full mt-4'>
                        <FormControl sx={{ width: "100%" }}>
                            <LabelCustom
                                variant='h6'
                                text='รายงานความคืบหน้าโครงการ'
                            />
                            <RadioGroup
                                value={1}
                                className='w-full flex gap-x-[120px]'
                                // onChange={(e) => setSelectProduct(e.target.value)}
                                row
                                aria-labelledby="target-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <span className='flex-1'>
                                    <FormControlLabel value={1} control={<Radio />} label={
                                        <div className='flex flex-col md:flex-row flex-1 w-full justify-center items-center'>
                                            <Typography className='w-full'>
                                                {"รายเดือน ทุกวันที่"}
                                            </Typography>
                                            <InputTextField
                                                disabled={permission?.find((list: any) => list?.code === "Notification.Edit")?.permit === false}
                                                inputProps={{ min: 0, max: 10 }}
                                                onkeypress={(even) => {
                                                    if (!/[0-9]/.test(even.key)) {
                                                        even.preventDefault();
                                                    }
                                                }}
                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setNotificationConfig((prev) => ({ ...prev, notifyProgressAt: Number(e.target.value) }))}
                                                value={notificationConfig.notifyProgressAt}
                                                placeholder='ระบุ'
                                            />
                                        </div>
                                    } />
                                </span>
                            </RadioGroup>
                        </FormControl>
                    </section>
                    <section className='w-full mt-4'>
                        <FormControl sx={{ width: "100%" }}>
                            <LabelCustom
                                variant='h6'
                                text='รายงานสถานะโครงการ'
                            />
                            <RadioGroup
                                value={1}
                                className='w-full flex gap-x-[120px]'
                                // onChange={(e) => setSelectProduct(e.target.value)}
                                row
                                aria-labelledby="target-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <span className='flex-1'>
                                    <FormControlLabel value={1} control={<Radio />} label={
                                        <div className='flex flex-col md:flex-row flex-1 w-full justify-center items-center'>
                                            <Typography className='w-full'>
                                                {"รายเดือน ทุกวันที่"}
                                            </Typography>
                                            <InputTextField
                                                disabled={permission?.find((list: any) => list?.code === "Notification.Edit")?.permit === false}
                                                onkeypress={(even) => {
                                                    if (!/[0-9]/.test(even.key)) {
                                                        even.preventDefault();
                                                    }
                                                }}
                                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => setNotificationConfig((prev) => ({ ...prev, notifyStatusAt: Number(e.target.value) }))}
                                                value={notificationConfig.notifyStatusAt}
                                                placeholder='ระบุ'
                                            />
                                        </div>
                                    } />
                                </span>
                            </RadioGroup>
                        </FormControl>
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default NotificationSetting